import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=8c343206"
import script from "./BaseSelector.vue?vue&type=script&lang=js"
export * from "./BaseSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports